@if (event?.starts_at || event?.location || event?.sub_location) {
<section class="eventsection-details__details">
  <div class="mdc-layout-grid eventsection-details__wrapper">
    <div class="mdc-layout-grid__inner eventsection-details__innerwrapper">
      @if (event?.starts_at) {
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone eventsection-details__item">
        <div class="eventsection-details__icon">
          <mat-icon>schedule</mat-icon>
        </div>
        <div class="eventsection-details__value">
          {{ { start: event?.starts_at, end: event?.ends_at } | datetimeRange : 'full' : timezone }}
        </div>
      </div>
      @if (event?.ends_at) {
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone eventsection-details__item">
        <div class="eventsection-details__icon">
          <mat-icon>hourglass_bottom</mat-icon>
        </div>
        <div class="eventsection-details__value">
          {{ event?.starts_at | DurationFromDatetime : event?.ends_at }}
        </div>
      </div>
      } } @if (event?.location || event?.sub_location) {
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone eventsection-details__item">
        <div class="eventsection-details__icon">
          <mat-icon>map</mat-icon>
        </div>
        <div class="eventsection-details__value">
          {{ event?.location }}{{ event?.sub_location ? ' ' + event?.sub_location : '' }}
        </div>
      </div>
      } @if (event?.event_type) {
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone eventsection-details__item">
        <div class="eventsection-details__icon">
          <mat-icon>early_on</mat-icon>
        </div>
        <div class="eventsection-details__value">
          {{ event?.event_type }}
        </div>
      </div>
      }
    </div>
  </div>
</section>
}
